import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Switch } from 'types';
import { CreateSwitchDto } from 'types/models/CreateSwitchDto';

export const createSwitch = ({
  data,
}: {
  data: CreateSwitchDto;
}): Promise<Switch> => {
  return axios.post('/api/switches', data);
};

type UseCreateSwitchOptions = {
  config?: MutationConfig<typeof createSwitch>;
};

export const useCreateSwitch = ({ config }: UseCreateSwitchOptions = {}) => {
  return useMutation({
    onError: (_, __, context: any) => {
      queryClient.invalidateQueries(['switches']);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['switches']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: createSwitch,
  });
};
